module.exports = __webpack_public_path__ + "84bbdf0e27757f8cd1f15b7f21d56f37.png";